<template>
  <q-layout view="hHh lpR fFf">
    <q-page-container>
      <q-page class="flex flex-center" style="min-height: 100vh; background: linear-gradient(135deg, #4688f5 0%, #ffffffff 100%);">
        <div class="activation-container q-pa-lg">
          <q-card class="activation-card">
            <q-card-section class="text-center q-pt-xl q-pb-lg">
              <img src="@/assets/douranovo.png" alt="DouraSoft Logo" style="width: 180px; height: auto;" />
            </q-card-section>

            <!-- Loading State -->
            <q-card-section v-if="listarActivatePass.preEtapa && !listarActivatePass.errorEtapa" class="text-center q-py-xl">
              <q-spinner color="blue-7" size="60px" />
              <p class="text-grey-7 q-mt-md text-body1">Carregando informações...</p>
            </q-card-section>

            <!-- Form de Nova Senha -->
            <q-card-section v-if="!salvarActivatePass.segundaEtapa && !listarActivatePass.errorEtapa && !listarActivatePass.preEtapa" class="q-px-xl q-pb-xl">
              <div class="q-mb-lg">
                <p class="text-grey-7 q-ma-none text-center">
                  Olá, <strong>{{ listarActivatePass.user.nome }}</strong>! Crie uma senha para ativar sua conta
                </p>
              </div>

              <q-form @submit="salvar" class="q-gutter-md">
                <q-input
                  v-model="senha.senha"
                  label="Nova Senha"
                  :type="isPwd ? 'password' : 'text'"
                  @update:model-value="val => verificaPass(val)"
                  :rules="[val => (regra1 && regra2 && regra3) || 'A senha não atende aos requisitos']"
                  bottom-slots
                >
                  <template v-slot:append>
                    <q-icon
                      :name="isPwd ? 'visibility_off' : 'visibility'"
                      class="cursor-pointer"
                      @click="isPwd = !isPwd"
                    />
                  </template>
                </q-input>

                <q-input
                  v-model="senha.confirmar"
                  label="Confirmar Senha"
                  type="password"
                  :rules="[
                    val => val === senha.senha || 'As senhas não coincidem'
                  ]"
                  bottom-slots
                />

                <q-card flat bordered class="q-mt-md">
                  <q-card-section>
                    <div class="text-subtitle2 text-weight-medium q-mb-sm">Requisitos da senha:</div>
                    
                    <div class="q-gutter-sm">
                      <div class="row items-center no-wrap">
                        <q-icon 
                          :name="regra1 ? 'check_circle' : 'radio_button_unchecked'" 
                          :color="regra1 ? 'positive' : 'grey-5'"
                          size="20px"
                          class="q-mr-sm"
                        />
                        <span :class="regra1 ? 'text-positive' : 'text-grey-7'" class="text-body2">
                          Mínimo de 6 caracteres
                        </span>
                      </div>

                      <div class="row items-center no-wrap">
                        <q-icon 
                          :name="regra2 ? 'check_circle' : 'radio_button_unchecked'" 
                          :color="regra2 ? 'positive' : 'grey-5'"
                          size="20px"
                          class="q-mr-sm"
                        />
                        <span :class="regra2 ? 'text-positive' : 'text-grey-7'" class="text-body2">
                          Pelo menos uma letra
                        </span>
                      </div>

                      <div class="row items-center no-wrap">
                        <q-icon 
                          :name="regra3 ? 'check_circle' : 'radio_button_unchecked'" 
                          :color="regra3 ? 'positive' : 'grey-5'"
                          size="20px"
                          class="q-mr-sm"
                        />
                        <span :class="regra3 ? 'text-positive' : 'text-grey-7'" class="text-body2">
                          Pelo menos um número
                        </span>
                      </div>
                    </div>
                  </q-card-section>
                </q-card>

                <div class="text-right q-mt-md">
                  <q-btn
                    label="Ativar Conta"
                    type="submit"
                    color="blue-7"
                    :loading="salvarActivatePass.loadAlterar"
                    :disable="!regra1 || !regra2 || !regra3 || senha.senha !== senha.confirmar"
                  >
                    <template v-slot:loading>
                      <q-spinner color="white" size="1em" />
                    </template>
                  </q-btn>
                </div>
              </q-form>
            </q-card-section>

            <!-- Link Inválido -->
            <q-card-section v-if="listarActivatePass.errorEtapa" class="text-center q-px-xl q-py-xl">
              <q-icon name="error_outline" size="80px" color="negative" class="q-mb-md" />
              <h5 class="text-h5 text-weight-medium q-ma-none q-mb-sm">Link Inválido</h5>
              <p class="text-grey-7 q-mb-lg">
                Este link de ativação já não é mais válido ou expirou.
              </p>

              <q-banner rounded class="bg-blue-1 q-mb-md">
                <template v-slot:avatar>
                  <q-icon name="info" color="blue-7" />
                </template>
                <div class="text-body2">
                  Deseja redefinir sua senha?
                  <router-link to="/alterar-senha" class="text-blue-7" style="text-decoration: none; font-weight: 500;">
                    Clique aqui
                  </router-link>
                </div>
              </q-banner>

              <q-btn
                label="Voltar ao Login"
                to="/login"
                color="blue-7"
              />
            </q-card-section>

            <!-- Sucesso -->
            <q-card-section v-if="salvarActivatePass.segundaEtapa && !listarActivatePass.errorEtapa" class="text-center q-px-xl q-py-xl">
              <q-icon name="check_circle" size="80px" color="positive" class="q-mb-md" />
              <h5 class="text-h5 text-weight-medium q-ma-none q-mb-sm">Senha Ativada!</h5>
              <p class="text-grey-7 q-mb-md">
                Sua senha foi criada com sucesso. Você já pode fazer login no sistema.
              </p>

              <q-linear-progress 
                :value="(5 - time) / 5" 
                color="blue-7" 
                class="q-mb-md"
                rounded
              />

              <p class="text-body2 text-grey-7 q-mb-lg">
                Redirecionando para o login em <strong>{{ time }}s</strong>
              </p>

              <q-btn
                label="Ir para Login Agora"
                to="/login"
                color="blue-7"
              />
            </q-card-section>

            <q-separator v-if="!listarActivatePass.preEtapa" />
            
            <q-card-section v-if="!listarActivatePass.preEtapa" class="text-center q-py-md">
              <router-link
                to="/login"
                class="text-blue-7"
                style="text-decoration: none; font-size: 14px;"
              >
                <q-icon name="arrow_back" size="18px" class="q-mr-xs" style="vertical-align: middle;" />
                Voltar ao Login
              </router-link>
            </q-card-section>
          </q-card>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import { createMetaMixin } from "quasar";
export default {
  name: "AtivarSenha",
  mixins: [createMetaMixin({ title: "DSB | Ativar Senha" })],
  data() {
    return {
      senha: {
        senha: "",
        confirmar: ""
      },
      time: 5,
      isPwd: true,
      regra1: false,
      regra2: false,
      regra3: false
    };
  },
  computed: {
    listarActivatePass() {
      return this.$store.getters.listarActivatePass;
    },
    salvarActivatePass() {
      return this.$store.getters.salvarActivatePass;
    }
  },
  methods: {
    verificaPass(pass) {
      this.regra1 = pass.length >= 6;
      this.regra2 = /[a-zA-Z]/.test(pass);
      this.regra3 = /[0-9]/.test(pass);
    },
    listar() {
      this.$store.dispatch("listarActivatePass", this.$route.params.id);
    },
    salvar() {
      let dados = {
        id: this.$route.params.id,
        senha: this.senha
      };
      this.$store.dispatch("salvarActivatePass", dados);
      
      let cronometro = setInterval(() => {
        this.time--;
        if (this.time === 0) {
          clearInterval(cronometro);
          this.$router.push({ path: '/login' });
        }
      }, 1000);
    }
  },
  mounted() {
    this.listar();
  }
};
</script>

<style lang="stylus" scoped>
.activation-container
  width 100%
  max-width 500px

.activation-card
  border-radius 16px
  box-shadow 0 10px 40px rgba(0, 0, 0, 0.1)

.q-btn
  transition all 0.3s ease

  &:hover
    transform translateY(-2px)
    box-shadow 0 4px 12px rgba(0, 0, 0, 0.15)
</style>